<template>
  <div id="app">
    <div>
      <confirm ref="confirm"></confirm>
      <loader v-model=statusval.loading></loader>
      <arksnackbar v-model="statusval"></arksnackbar>
    </div>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>
                <v-layout align-center>
                  <v-img v-if="logo!=null" :src="getImgUrl(logo)" height="50px" width="100px" contain>
                  </v-img> &nbsp;
                  {{title}}
                </v-layout>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile  @click="getExcel()">
                    <v-list-tile-title> {{ $t('Excel-File-Example') }} </v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-layout align-center justify-start row fill-height>
                    <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data"
                      v-model="valid" lazy-validation>
                      <input hidden type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" />
                    </v-form>
                    <v-btn :loading="false" :disabled="false" color="info" dark @click="addFiles()">
                      <v-icon color="white" left>attach_file</v-icon> {{ $t('Select-Transfer-File') }}
                    </v-btn>

                    <div v-show="load2">
                      <v-btn small="" fab @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                        @click="btnSubmitFiles()" color="info" dark>
                        <v-icon>redo</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{$t('Transfer-Selected')}}</span>
                      </v-tooltip>
                    </div>



                    <v-badge v-if="logo=='iatilogo' || logo=='biletbanklogo' || logo=='biletalllogo' || logo=='ark' || logo=='XQ'" color="white" :overlap="true">
                        <template v-slot:badge>
                            <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                        </template>

                        <v-btn small="" @mouseenter="tooltip = true"
                            @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                            color="info" fab dark>
                            <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-tooltip bottom="" :activator="el" v-model="tooltip">
                            <span>{{$t('Add-Search-Filter')}}</span>
                        </v-tooltip>

                    </v-badge>

                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md4>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-alert :value="true" :color="alertcolor" icon="check_circle" outline>
                    {{alertmessage}}
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{$t('Transferred-Tickets')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
                </v-text-field>
              </v-toolbar>

              <v-card>
                <v-data-table :headers="headers" :rows-per-page-items="[20,500]" :items="itemsok" :search="search3">
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.biletNo }}</td>
                      <td class="text-xs-left">{{ props.item.aciklama }}</td>
                      <v-btn icon class="mx-0" @click="git(props.item)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    {{ $t('No-records-searched-for', { value: search3}) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="red">
                <v-toolbar-title>{{$t('Tickets-Not-Transferred')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field flat="" solo-inverted="" hide-details v-model="search4" :label="$t('Search')" append-icon="search">
                </v-text-field>
              </v-toolbar>
              <v-card>
                <v-data-table :headers="headers" :rows-per-page-items="[20,500]" :items="itemsno" :search="search4">
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.biletNo }}</td>
                      <td class="text-xs-left">{{ props.item.aciklama }}</td>
                      <v-btn icon class="mx-0" @click="git(props.item)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    {{ $t('No-records-searched-for', { value: search4}) }}
                    </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>

      <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
        <v-card flat color="grey lighten-5">
          <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-flex mt-2 xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row="" wrap="">
                      <v-flex xs12 sm12 md12>
                        <v-autocomplete hide-details="" v-if="logo=='iatilogo' || logo=='XQ'" clearable :items="itemsairlinelist"
                          v-model="iatiparams.AcenteKodu" :label="$t('Agency-Code')" item-text="Title"
                          item-value="HavaYoluKodu">
                        </v-autocomplete>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-checkbox v-model="iatiparams.KomisyonTutarEkle"  v-if="logo=='iatilogo'" :label="$t('Add-Commission-Amount')" hide-details="">
                        </v-checkbox>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-checkbox v-model="iatiparams.SCTutarEkle"  v-if="logo=='iatilogo'" :label="'SC' + $t('Add-Amount') " hide-details="">
                        </v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                       <v-autocomplete hide-details="" v-if="logo=='biletbanklogo' || logo=='biletalllogo' || logo=='ark'" clearable :items="itemsairlinelist"
                          v-model="biletbankparams.AcenteKodu" :label="$t('Agency-Code')" item-text="Title"
                          item-value="HavaYoluKodu">
                        </v-autocomplete>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-checkbox v-model="biletbankparams.ServisAlisServis"  v-if="logo=='biletbanklogo'|| logo=='biletalllogo' || logo=='ark'"   :label="this.$t('Save-service-fee-to-pickup-service')" hide-details="">
                        </v-checkbox>
                      </v-flex>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="filtreiptal()">{{$t("cancel_button")}}</v-btn>
            <v-btn color="blue darken-1"   flat @click="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>

    </v-app>
  </div>
</template>

<script>
  import confirm from "@/components/app/coper/comp/confirm.vue";
  import loader from "@/components/app/coper/comp/loader.vue";
  import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
  import customdialog from "@/components/app/coper/comp/customdialog.vue";
  import logoo from '../../../../assets/control'

  import tool from "../../coper/tools";
  import auth from "../../../../api/auth"

  export default {
    props: ["value", "title", "status", "logo"],
    data() {
      return {
        filtrevarmi:false,
        iatiparams: {
          AcenteKodu: null,
          SCTutarEkle: false,
          KomisyonTutarEkle: false,
        },
          biletbankparams: {
          AcenteKodu: null,
          ServisAlisServis: false,
        },
        dialogfiltre: false,
        itemsairlinelist: [],
        headers: [{
            text: this.$t('Ticket-No'),
            value: 'biletNo'
          },
          {
            text: this.$t('Status'),
            value: 'aciklama'
          }

        ],
        itemsno: [],
        itemsok: [],
        alertcolor: "red",
        alertmessage: this.$t('file-has-been-chosen'),
        search3: '',
        search4: '',
        files: [],
        valid: true,
        load2: false,
        load3: false,
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      };
    },
    components: {
      confirm,
      loader,
      arksnackbar,
      customdialog
    },

    computed: {
      model: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit("input", newValue);
        }
      },
      statusval: {
        get: function () {
          if (this.status == null) {
            return tool.NewSatatus();
          } else {
            return this.status;
          }
        }
      }
    },

    watch: {
      model(val) {
        this.watchmodel(val);
      }
    },
    mounted() {
      this.el = this.$refs.fab.$el

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params = {
        CompanyCode: credentials.SirketKodu
      }

      this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.itemsairlinelist = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'

          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'

          this.snackbar = true
        }
      })
    },

    methods: {
      filtrekayit() {
        this.dialogfiltre = false
        this.filtrevarmi=true
        this.handleFilesUpload();
      },
      filtreiptal() {
        this.iatiparams.AcenteKodu = null
        this.iatiparams.KomisyonTutarEkle = false
        this.iatiparams.SCTutarEkle = false
        this.dialogfiltre = false
        this.biletbankparams.AcenteKodu=null
        this.biletbankparams.ServisAlisServis=false
        this.filtrevarmi=false
      },
      filtrele() {
        this.dialogfiltre = true
      },
      getImgUrl(img) {
        return logoo.logoControl(img);
      },
      getExcel() {
        this.$http.post(auth.API_URL + "api/TicketStream/ExampleExcelFile", null, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {

          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "OrnekExcel.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

          }
        })
      },

      watchmodel(val) {
        this.itemsok = []
        this.itemsno = []

        if (val) {

          val.forEach(element => {
            if (element.basarili) {
              this.itemsok.push(element)
              //aktarilan = aktarilan + 1
            } else {
              this.itemsno.push(element)
            }
          });

        }
      },
      handleFilesUpload() {

        this.files = []

        let uploadedFiles = this.$refs.files.files;

        if (uploadedFiles.length > 0) {
          this.alertcolor = "success";
          this.alertmessage = this.$t('Total') + " " + uploadedFiles.length + " " + this.$t('pcs-of-files-selected');
          this.load2 = true;

          for (var i = 0; i < uploadedFiles.length; i++) {
            if(10485760 > uploadedFiles[i].size){
              this.files.push(uploadedFiles[i]);
            }else{
              this.snackbar = true;
              this.text1 = this.$t('The-file-size-cannot-be-larger-than-10mb.')
            }
          }


          if (this.logo == 'iatilogo') {

            var eklerIATI = {
              AcenteKodu: this.iatiparams.AcenteKodu,
              SCTutarEkle: this.iatiparams.SCTutarEkle,
              KomisyonTutarEkle: this.iatiparams.KomisyonTutarEkle
            }
            this.files.push(eklerIATI)

          }
          if(this.logo=='XQ'){
            var eklerSunExpress = {
              AcenteKodu: this.iatiparams.AcenteKodu,
            };
            this.files.push(eklerSunExpress);
          }

           if (this.logo == 'biletbanklogo' || this.logo=='biletalllogo' || this.logo=='ark') {


             if (this.biletbankparams.AcenteKodu==undefined) {
               this.biletbankparams.AcenteKodu=null
             }


            var ekler = {
              AcenteKodu: this.biletbankparams.AcenteKodu,
              ServisAlisServis: this.biletbankparams.ServisAlisServis,

            }


            this.files.push(ekler)

          }

        } else {
          this.alertmessage = this.$t('file-has-been-chosen');
          this.alertcolor = "red";
          this.load2 = false;
        }

      },
      btnSubmitFiles() {
        
        if(this.logo == 'biletbanklogo' && this.biletbankparams.AcenteKodu == null){
          this.text1 = this.$t('Agency-Code-cannot-be-empty-You-must-choose-a-filter')
          this.snackbar = true
          return false;
        }

        this.$refs.confirm
          .open(this.$t('Ticket-Transfer'), this.title + " " + this.$t('Transfer-Files?'), {
            color: "red",
          })
          .then(confirm => {
            if (confirm == true) {


              this.$emit("submitfile", this.files,this.biletbankparams);
            }
          });

      },

      removeFile(key) {
        this.files.splice(key, 1);
      },
      removeAllFiles() {
        this.$refs.confirm
          .open(this.$t('Delete-File'), this.$t('Delete-the-Files'), {
            color: "red",
          })
          .then(confirm => {
            if (confirm == true) {
              this.files = [];
            }
          });

      },

      addFiles() {
        this.$refs.files.click();
      },

      load1() {
        return (this.files.length <= 0);
      },
      git: git
    },

  };

  function git(v) {

    if (v.biletNo.length == 13) {
      var str = v.biletNo.slice(3)
    } else {
      var str = v.biletNo
    }

    var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.bilet.HavayoluKodu + '&biletno=' + str + '&ucustipi=' +
      v.bilet.UcusTipi

    window.open(url, '_blank')
  }
</script>